<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedDate"
        :label="label"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        outlined
        dense
        clearable
        :rules="requiredRules"
        @click="clearData()"
        @click:clear="clearData()"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      v-model="inputVal"
      no-title
      scrollable
      :max="getYearsModified(5)"
      min="2020-01-01"
      :locale="language"
    >
      <!-- <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">
        Cancel
      </v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(date)">
        OK
      </v-btn> -->
    </v-date-picker>
  </v-menu>
</template>

<script>
import dayjs from "dayjs";
import validator from "@/helper/validator";
import { getYearsModified } from "@/helper/dateTime";
require("dayjs/locale/th");
export default {
  name: "DatePicker",
  props: ["value", "label", "no_required"],

  data: () => ({
    menu: false,
  }),

  computed: {
    language() {
      return this.$root.$i18n.locale;
    },

    requiredRules: function() {
      if (this.no_required) return [];
      else return [validator.required];
    },
    formattedDate() {
      if (this.value && this.value !== "0000-00-00 00:00:00") {
        if (this.language === "en")
          return dayjs(this.value, "YYYY-MM-DD HH:mm:ss")
            .locale("en")
            .format("D MMMM YYYY");
        else if (this.language === "th")
          return dayjs(this.value, "YYYY-MM-DD HH:mm:ss")
            .locale("th")
            .format("D MMMM BBBB");
      }
      return "";
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        this.menu = false;
      },
    },
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  methods: {
    getYearsModified,

    clearData() {
      this.$emit("input", null);
    },
  },
};
</script>
